// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"be1085d2","222":"f20bc530","332":"0520f8b1","458":"ffcac9ff","616":"0520f8b1","671":"b727fb47","703":"23147288","790":"72332423","897":"0520f8b1"}[chunkId] + ".chunk.css";
};